
const ContactInfo = () => {
  return (
    <div>
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 sm:mb-8">
        Informations de <span className="text-blue-600">contact</span>
      </h2>
      
      <div className="space-y-5 sm:space-y-6 mb-8 sm:mb-10">
        <div className="flex items-start group">
          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
            <i className="ri-map-pin-line text-xl sm:text-2xl text-blue-600"></i>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-1 sm:mb-2 text-base sm:text-lg">Adresse</h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              31 Avenue des pins, Q/Bel air<br />
              C/Kampemba, Lubumbashi/Katanga<br />
              RDC
            </p>
          </div>
        </div>

        <div className="flex items-start group">
          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-teal-100 to-teal-50 rounded-xl flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
            <i className="ri-phone-line text-xl sm:text-2xl text-teal-600"></i>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-1 sm:mb-2 text-base sm:text-lg">Téléphone</h3>
            <p className="text-sm sm:text-base text-gray-600">+243 833111081</p>
          </div>
        </div>

        <div className="flex items-start group">
          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
            <i className="ri-mail-line text-xl sm:text-2xl text-blue-600"></i>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-1 sm:mb-2 text-base sm:text-lg">Email</h3>
            <a 
              href="mailto:contact@gge-cd.com" 
              className="text-sm sm:text-base text-gray-600 hover:text-blue-600 transition-colors cursor-pointer break-all"
            >
              contact@gge-cd.com
            </a>
          </div>
        </div>

        <div className="flex items-start group">
          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-teal-100 to-teal-50 rounded-xl flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
            <i className="ri-time-line text-xl sm:text-2xl text-teal-600"></i>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-1 sm:mb-2 text-base sm:text-lg">Horaires d'ouverture</h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Lundi - Vendredi: 8h00 - 18h00<br />
              Samedi: 9h00 - 17h00<br />
              Dimanche: Fermé
            </p>
          </div>
        </div>
      </div>

      <div className="rounded-xl overflow-hidden shadow-lg">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3973.8!2d27.4794!3d-11.6609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19723f0000000000%3A0x0!2sLubumbashi%2C%20Katanga%2C%20RDC!5e0!3m2!1sfr!2sfr!4v1635959000000!5m2!1sfr!2sfr"
          width="100%"
          height="250"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="sm:h-[300px] md:h-[350px]"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactInfo;
